import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import api from "../../api";
import { notify } from "../../utils/toast";
import logo from "../../assets/images/logo.png";
import "../admin/login.css";
import supportAction from "../../redux/support/action";

export const SupportLogin = ({ setAuthType }) => {
  const { setSupportMember } = supportAction;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [showPass, setShowPass] = useState(false);
  const [loader, setLoader] = useState(false);
  const [data, setData] = useState({ email: "", password: "" });

  const onTextChange = (e) => setData({ ...data, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!data.email || !data.password) {
      notify.error("Email and password are required");
      return;
    }
    setLoader(true);
    try {
      const res = await api.supportLogin({ email: data.email, password: data.password });
      if (!res?.success) throw new Error(res?.message || "Login failed");

      axios.defaults.headers.common["Authorization"] = res.token;
      localStorage.setItem("supporttoken", res.token);
      setAuthType("support");
      dispatch(setSupportMember(res));
      // Navigate to first permitted page or dashboard
      const first = res?.member?.permissions?.[0];
      const pageMap = {
        dashboard: "/admin/dashboard", vehicles: "/admin/vehicles", drivers: "/admin/drivers",
        routes: "/admin/routes", students: "/admin/students", fuel: "/admin/fuel",
        fees: "/admin/fees", feeReceipts: "/admin/fee-receipts", salary: "/admin/salary",
        loans: "/admin/loans", paymentMethod: "/admin/payment-method",
        maintenance: "/admin/maintenance", enquiries: "/admin/enquiries",
        bookings: "/admin/bookings", entry: "/admin/entry", bill: "/admin/bill",
      };
      navigate(first ? (pageMap[first] || "/admin/dashboard") : "/admin/dashboard");
    } catch (e) {
      notify.error(e?.response?.data?.message || e.message || "Invalid credentials");
    } finally {
      setLoader(false);
    }
  };

  return (
    <div className="admin-login-page">
      {/* Left Panel */}
      <div className="admin-login-left">
        <div className="admin-login-decor1" />
        <div className="admin-login-decor2" />
        <div className="admin-login-decor3" />
        <div className="admin-login-logo-wrap">
          <img src={logo} alt="Shabbir Transport" className="admin-login-logo-img" />
        </div>
        <div className="admin-login-brand-name">Shabbir Transport</div>
        <div className="admin-login-brand-tagline">
          Support staff portal — limited access as configured by admin
        </div>
      </div>

      {/* Right Panel */}
      <div className="admin-login-right">
        <div className="admin-login-form-card">
          <div className="admin-login-form-title">Support Portal</div>
          <div className="admin-login-form-subtitle">Sign in with your support account</div>

          <form noValidate onSubmit={handleSubmit}>
            <div className="admin-login-field-group">
              <label className="admin-login-label">Email Address</label>
              <div className="admin-login-input-wrap">
                <span className="admin-login-input-icon">
                  <i className="fa-solid fa-envelope" />
                </span>
                <input
                  type="email"
                  name="email"
                  placeholder="support@example.com"
                  className="admin-login-input"
                  onChange={onTextChange}
                />
              </div>
            </div>

            <div className="admin-login-field-group">
              <label className="admin-login-label">Password</label>
              <div className="admin-login-input-wrap">
                <span className="admin-login-input-icon">
                  <i className="fa-solid fa-lock" />
                </span>
                <input
                  type={showPass ? "text" : "password"}
                  name="password"
                  placeholder="Enter your password"
                  className="admin-login-input"
                  onChange={onTextChange}
                />
                <button
                  type="button"
                  className="admin-login-eye-btn"
                  onClick={() => setShowPass(!showPass)}
                >
                  <i className={`fa-solid ${showPass ? "fa-eye-slash" : "fa-eye"}`} />
                </button>
              </div>
            </div>

            <button
              type="submit"
              className="admin-login-submit-btn"
              style={{ opacity: loader ? 0.7 : 1 }}
              disabled={loader}
            >
              {loader ? "Signing in..." : "Sign In"}
            </button>
          </form>

          <a href="/" className="admin-login-back-link">← Back to website</a>
        </div>
      </div>
    </div>
  );
};
